import { useParams } from "react-router-dom";
import {isUndefined} from "../../../util/is-type";

export interface ISongsPageLibrarySubNavigationItemLogic {
  isActive: boolean;
}

export const useSongsPageLibrarySubNavigationItemLogic = (navItemFilterSubset?: string): ISongsPageLibrarySubNavigationItemLogic => {
  const {libraryFilterSubset} = useParams();

  const isActive = (
    (
      isUndefined(navItemFilterSubset) &&
      isUndefined(libraryFilterSubset)
    ) ||
    navItemFilterSubset === libraryFilterSubset
  );

  return {
    isActive,
  };
}
